'use strict';

var App = require('app');
var AppState = require('app_state');
var Misc = require('utils/misc');

var Bookmark = Backbone.Model.extend({
    urlRoot: function () {
        return '/api/v1/bookmarks/' + this.get('page') + '/' + this.get('category');
    },
});

var BookmarkCollection = Backbone.Collection.extend({
    url: function () {
        return '/api/v1/bookmarks/' + this.page + '/' + this.category;
    },
    model: Bookmark,
    comparator: function (modelA, modelB) {
        var a = modelA.attributes.name.toLowerCase();
        var b = modelB.attributes.name.toLowerCase();
        if (a == b) {
            return 0;
        }
        return a < b ? -1 : 1;
    },
    initialize: function (options) {
        this.page = options.page;
        this.category = options.category || '';
    },
});

var API = {
    getBookmarks: function (page, category) {
        category = category || Misc.getDeviceCategoryFromURL();
        var defer = $.Deferred();
        var bm = new BookmarkCollection({
            page: page,
            category: category,
        }).fetch({
            success: function (collection, response, options) {
                collection.each(function (model) {
                    model.set('pageConfiguration', JSON.parse(model.get('pageConfiguration')));
                });
                collection.fetchSuccessfull = true;
                defer.resolve(collection);
            },
            error: function (collection, response, options) {
                collection.reset();
                collection.fetchSuccessfull = false;
                defer.resolve(collection);
            },
        });
        return defer.promise();
    },
};

App.reqres.setHandler('bookmarks:get', function (page, category) {
    return API.getBookmarks(page, category);
});

module.exports = {
    Bookmark: Bookmark,
    BookmarkList: BookmarkCollection,
};
